import React, { lazy, Suspense } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';

// Lazy load all non-critical components to improve LCP
const Disclaimer = lazy(() => import('../components/Disclaimer'));
const About = lazy(() => import('../components/About'));
const Guides = lazy(() => import('../components/Guides'));
const FAQ = lazy(() => import('../components/FAQ'));
const News = lazy(() => import('../components/News'));
const Contact = lazy(() => import('../components/Contact'));
const Footer = lazy(() => import('../components/Footer'));

const Home = () => {
  return (
    <div className="min-h-screen">
      <Suspense fallback={null}>
        <Disclaimer />
      </Suspense>
      <Header />
      <Hero />
      <Offers />
      <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
        <About />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
        <Guides />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <News />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <Contact />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;

